import { authenticatedUserSchema } from '../../../schemas/authenticated-user.schema';
import { z } from 'zod/v4';

export const switchedAccountUserSchema = authenticatedUserSchema
  .extend({
    userBelongsToAccount: z.boolean(),
  })
  .omit({
    forcePasswordReset: true,
  });

export type SwitchedAccountUser = z.infer<typeof switchedAccountUserSchema>;
